export default __webpack_public_path__ + "static/media/swoosh_ching.a4c7af2f.mp3";